import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MetaState } from './types'
import { HYDRATE } from 'next-redux-wrapper'

const initialState: MetaState = {
  title: null,
  description: null,
  keywords: null,
  socialImage: null,
  canonical: null
}

const metaSlice = createSlice({
  name: 'meta',
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<MetaState['title']>) => {
      state.title = action.payload
    },
    setDescription: (state, action: PayloadAction<MetaState['description']>) => {
      state.description = action.payload
    },
    setKeywords: (state, action: PayloadAction<MetaState['keywords']>) => {
      state.keywords = action.payload
    },
    setMeta: (state, action: PayloadAction<MetaState>) => {
      state.title = action.payload.title || null
      state.description = action.payload.description || null
      state.keywords = action.payload.keywords || null
      state.socialImage = action.payload.socialImage || null
      state.canonical = action.payload.canonical || null
    },
    setSocialImage: (state, action: PayloadAction<MetaState['socialImage']>) => {
      state.socialImage = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.meta,
      }
    })
  },
})

export const { setDescription, setTitle, setKeywords, setMeta, setSocialImage } = metaSlice.actions

export default metaSlice
